// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {Link} from 'react-router';

const LinkOrSpan = props => props.actualValue ?
    <Link to={props.link}>
        {props.displayValue}
    </Link> :
    <span>
        {props.displayValue}
    </span>;

LinkOrSpan.displayName = 'LinkOrSpan';
LinkOrSpan.propTypes = {
    actualValue: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    displayValue: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    link: PropTypes.string
};

export default LinkOrSpan;



// WEBPACK FOOTER //
// ./src/shared/components/link-or-span/index.js